<section class="header">
    <nlr-header></nlr-header>
</section>
<section
    id="inner"
    class="content">
    @if (userDetailsViewModel) {
        <div class="container-fluid">
            <div class="h4"
                ><p>Welcome {{getUserDisplayName()}}.</p></div
            >
            <div class="well">
                <h5>Your surveyor registration details as follows:</h5>
                <ul>
                    <li>
                        <label for="surveyoremail">Your login email address:</label>
                        <p id="surveyoremail">{{userDetailsViewModel.surveyorEmail}}</p>
                    </li>
                    <li>
                        <label for="surveyorcertexp">Your digital signature certificate expiry:</label>
                        <p id="surveyorcertexp">{{userDetailsViewModel.certificateExpiry}}</p>
                    </li>
                    @if (userDetailsViewModel.userCertificateExists) {
                        <li ng-show="userAccountDetailsController.userDetailsViewModel.userCertificateExists">
                            <label for="surveyorcertthumb">Your digital signature certificate thumbprint:</label>
                            <p id="surveyorcertthumb">{{userDetailsViewModel.certificateThumbprint}}</p>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
</section>

<section class="footer">
    <nlr-footer></nlr-footer>
</section>
